import { CIcon } from '~/icons/types'

export const ciBooking: CIcon = {
  width: '24',
  height: '24',
  paths: [
    {
      d:
        'M18.684 14.984H9.7a.953.953 0 0 0-.925.765 2.354 2.354 0 0 0-3.652 2.958H3.361v-3.223a.5.5 0 0 0-1 0V22a.5.5 0 0 0 1 0v-2.293h16.684V22a.5.5 0 1 0 1 0v-4.654a2.364 2.364 0 0 0-2.361-2.362Zm-13 2.362a1.362 1.362 0 1 1 1.366 1.36 1.364 1.364 0 0 1-1.362-1.36h-.004Zm4.045 1.36L9.7 15.985h8.98a1.363 1.363 0 0 1 1.361 1.362v1.36H9.729ZM22.7 9.283 12.553 1.78a1.424 1.424 0 0 0-1.7 0L.7 9.283a.5.5 0 0 0 .594.8L2.361 9.3v2.825a.5.5 0 0 0 1 0V8.56l8.086-5.977a.431.431 0 0 1 .512 0l8.086 5.977v3.564a.5.5 0 0 0 1 0V9.3l1.064.787a.502.502 0 0 0 .82-.47.5.5 0 0 0-.225-.33l-.004-.004Z',
      fill: 'currentColor'
    }
  ],
  ellipses: [],
  circles: [],
  name: 'booking',
  type: 'thin'
}
